// mobileTip.vue
<template>
<transition name='fade'>
  <div class="Box" v-if="show">
    <div
    @click="btnClick"
      class="contentBox"
      :class="
        type === 'success'
          ? 'success'
          : type === 'error'
          ? 'error'
          : type === 'info'
          ? 'info'
          : 'success'
      "
    >
      <!-- 这里的图标用的是elementUI的图标 -->

      <i class="el-icon-success icon" v-if="type === 'success'"></i>
      <i class="el-icon-warning icon" v-if="type === 'error'"></i>
      <i class="el-icon-error icon" v-if="type === 'info'"></i>

      <div :class="msg.length>6?'font16':''">{{ msg }}</div>
    </div>
  </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  computed:{

  },
  methods: {
    btnClick () {
      // this.click()
      this.show = false
    }
  },

  props: {
    msg: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "success",
    },
  },
};
</script>

<style scoped lang='less'>
// 渐变过渡
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-5%);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all .35s;
  }
.Box {
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  justify-content: flex-end;
  padding-right: 20px;
  align-items: flex-start;
  z-index: 999999;
}
.contentBox {
  margin-top: 104px;
  padding-top: 24px;
  width: 144px;
  height: 144px;
  background: #d98787;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
  max-width: 80%;
  min-height: 120px;

  border-radius: 8px;
  text-align: center;

  /* font-size:28px; */
}

.contentBox {
  .icon {
    font-size: 48px;
    color: white;
    // margin-bottom: 16px;
  }
  div {
    word-break: break-all;
    padding: 0 16px;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
    margin-top: 12px;
    &.font16{
      font-size: 14px;
      // text-align: left;
      line-height: 21px;
    }
  }
  &.success {
    background-color: #47a896;
  }
  &.error {
    background: #d98787;
  }
  &.info {
    background-color: #47a896;
  }
}
</style>

